import styled from 'styled-components'

export const CenterStuff = styled.div`
  width: 100%;
  display: flex;
  height: 100vh;
  align-items: center;
  justify-content: center;
`
